/**
 * The dashboard's feedback-by-type section (SF-5095): the customer layers, then the ServeFirst
 * Live company on its own line when there is one, since it is never a customer.
 */
import { Typography } from 'antd';
import { CompanyLink } from '../../../components/usage/CompanyLink';
import { UsageLayers } from '../../../components/usage/UsageLayers';
import type { PlatformUsage } from '../../../components/usage/usageClient';
import { formatNumber } from '../../../utils/format';

const { Text } = Typography;

export const FeedbackLayers: React.FC<{ data: PlatformUsage }> = ({ data }) => (
  <>
    <UsageLayers totals={data.totals} label="Customer feedback by type" />
    {data.internal && (
      <Text type="secondary" style={{ display: 'block', marginTop: 12 }}>
        ServeFirst Live (
        <CompanyLink companyId={data.internal.company_id} name={data.internal.name} />
        ): {formatNumber(data.internal.totals.total_feedback)} feedback, not in the customer figures
      </Text>
    )}
  </>
);
